//helpers
import { getGlobalThis } from "shared/helpers/utils";
import {
    captureError,
    captureRequest,
    captureResponse,
    captureResponseError,
} from "shared/helpers/logger";

const DEFAULT_HEADERS = {};

interface IApiHelperOptions {
    method?: string;
    mode?: string;
    cache?: string;
    credentials?: string;
    headers?: { [key: string]: string };
    redirect?: string;
    referrer?: string;
    body?: any;
    isBodyJSON?: boolean;
}

const getFormData = (data: any) => {
    const formBody = [];

    for (let property in data) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }

    return formBody.join("&");
};

/**
 *
 * A wrapper over fetch API, with some defaults
 */
export const ApiHelper = (
    url: string,
    {
        method = "GET",
        mode = "cors",
        cache = "no-cache",
        credentials = __BROWSER__ ? "same-origin" : undefined,
        headers = {},
        isBodyJSON = false,
        redirect,
        referrer,
        body,
    }: IApiHelperOptions = {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: __BROWSER__ ? "same-origin" : undefined,
        headers: {},
        isBodyJSON: false,
    }
) => {
    const reqHeaders = {
        ...DEFAULT_HEADERS,
        ...(method === "POST" && body
            ? { "Content-Type": "application/x-www-form-urlencoded" }
            : {}),
        ...(isBodyJSON ? { "Content-Type": "application/json" } : {}),
        ...headers,
    };

    let requestBody = body;
    if (body !== undefined && method === "POST") {
        requestBody = isBodyJSON ? JSON.stringify(body) : getFormData(body);
    }

    const fetchOptions = {
        method,
        mode,
        cache,
        credentials,
        redirect,
        referrer,
        body: requestBody,
        headers: reqHeaders, // TODO: Custom headers client side - pass cookie in case of SSR
    };

    const globalThis = getGlobalThis();
    const fetch = globalThis.fetch;

    const fetchCall = fetch(url, fetchOptions);
    if (__SERVER__) {
        const requestParams = { url, ...fetchOptions };
        const requestId = captureRequest(requestParams);
        fetchCall
            .then((res: Response) => {
                if (res.status >= 400) {
                    captureResponseError(res, requestId);
                } else {
                    captureResponse(res, requestId);
                }
            })
            .catch((err: Error) => {
                captureError(err, requestId, url);
            });
    }

    return fetchCall;
};
